import MyTabs from "../../../components/MyTabs";
import ITBasic from "./Basic";

const IntegratedTimeline = (props) => {

    const tabs = [
        { id: "basic", title: "Basic", Component: ITBasic },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default IntegratedTimeline;